<template>
  <div id="vista-previa-acuerdo" v-if="acuerdo_comercial_copy">

    <div v-if="!modo_eliminacion">
      <div class="titulo-principal mb-6">Confirmación del acuerdo</div>

      <div :class="acuerdo_comercial_copy.tipo_propuesta !== TIPO_ACUERDO_POR_DEFECTO ? 'mb-4' : ''">

        <div class="mt-4 titulo-principal-celeste">Vista previa</div>

        <div v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO" class="label-administracion mb-4 mt-2">
          Acuerdo por defecto para la administración: {{ acuerdo_comercial_copy.administracion.nombre }}
        </div>
      </div>

      <!-- Chip info sobre acuerdos por defecto -->
      <div class="seccion" v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO">
        <ca-chip
          :item="{label: 'Los nuevos consorcios de la administración serán vinculados automáticamente<br>a este acuerdo' }"
          disabled
          outline
          contentClass="chip-custom chip-informativo"
        >
          <div slot="izquierda">
            <v-icon class="icon-info">info</v-icon>
          </div>
        </ca-chip>
      </div>

      <!-- Select de consorcios -->
      <div v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_VINCULADO_A_CONSORCIO && !modo_asignacion_libre" class="seccion selector-consorcio pa-4">
        <span class="label-eleccion-consorcio">Elegí un consorcio para previsualizar su acuerdo:</span>
        <v-select
          label="Consorcios"
          :items="consorciosSeleccionables"
          v-model="consorcio_seleccionado"
          @change="actualizarRelacionConsorcio"
        >
        </v-select>
      </div>

      <!-- Slot utilizado en asignacion de acuerdos libres para mostrar el consorcio deshabilitado -->
      <slot name="input-consorcio-pre-seleccionado"></slot>
    </div>

    <div class="vista-previa">

      <!-- Consorcio destinado -->
      <div v-if="acuerdo_comercial_copy.consorcio_propuesta_libre && !modo_asignacion_libre" class="seccion">
        <div class="titulo-seccion">Consorcio</div>
        <hr class="linea-separadora">
        <div class="label-titulo-acuerdo"> {{ acuerdo_comercial_copy.consorcio_propuesta_libre }}</div>
      </div>

      <!-- Modalidad -->
      <div v-if="acuerdo_comercial_copy.tipo_propuesta !== TIPO_ACUERDO_POR_DEFECTO && acuerdo_comercial_copy.solo_comunicacion" class="seccion">
        <div class="titulo-seccion">Modalidad "Solo comunicación"</div>
        <hr class="linea-separadora">
        <div class="texto-seccion">Se aplica un 50% sobre el precio base de UF</div>
      </div>

      <!-- Tipo de consorcio -->
      <div v-if="acuerdo_comercial_copy.tipo_propuesta !== TIPO_ACUERDO_POR_DEFECTO" class="seccion">
        <div class="titulo-seccion">Tipo de consorcio</div>
        <hr class="linea-separadora">
        <div class="texto-seccion">
          {{ getTituloTipoConsorcio(acuerdo_comercial_copy.tipo_propuesta !== TIPO_ACUERDO_LIBRE ? consorcio_seleccionado.tipo : acuerdo_comercial_copy.tipo_producto) }}
        </div>
      </div>

      <!-- Espacio para inyectar algun componente antes de la sección de unidades funcionales  -->
      <slot name="pre-unidades-funcionales"></slot>

      <!-- Unidades funcionales -->
      <div class="seccion">
        <div class="titulo-seccion">Unidades funcionales</div>

        <!-- Cuenta de ufs -->
        <template v-if="consorcio_seleccionado">
          <hr class="linea-separadora">
          <div class="mt-2">
            <span class="texto-seccion">UFs Principales: {{ this.consorcio_seleccionado.cantUfsPrimarias }}</span>
            <br>
            <div class="texto-seccion">Cocheras: {{ this.consorcio_seleccionado.cantidadCocheras }}</div>
          </div>
        </template>

        <!-- NO se muestra el chip: Si selecciono un consorcio y este tiene más del minimo de ufs facturables permitidas, caso contrario siempre hay mensaje -->
        <div v-if="mostrarChipUnidadesFuncionales">
          <hr class="linea-separadora">
          <div class="texto-seccion">{{ this.itemUfsFacturarDebajo.label }}</div>
          <hr v-if="this.itemUfsFacturarDebajo.label2" class="linea-separadora">
          <div class="texto-seccion">{{ this.itemUfsFacturarDebajo.label2 }}</div>
        </div>

        <!-- Descuentos temporales -->
        <div class="sub-seccion">
          <div class="titulo-sub-seccion">
            <span>Descuentos temporales</span>
          </div>
          <div class="contenido-sub-seccion">
            <span v-if="!descuentos_temporales.length" class="texto-seccion">
              No se aplican
            </span>
            <div v-else>
              <div v-for="(descuento_temporal, index_descuento_temporal) in this.descuentos_temporales" :key="index_descuento_temporal">
                <span class="texto-seccion" v-if="index_descuento_temporal === 0">
                  Primeros {{ descuento_temporal.meses }} meses: {{  descuento_temporal.descuento }}%
                </span>
                <span class="texto-seccion" v-else>
                  Próximos {{ descuento_temporal.meses }} meses: {{  descuento_temporal.descuento }}%
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Descuento permanente -->
        <div class="sub-seccion">
          <div class="titulo-sub-seccion">
            <span>Descuento permanente</span>
          </div>
          <div class="contenido-sub-seccion">
            <span class="texto-seccion">{{ this.descuento_permanente_uf ? this.descuento_permanente_uf + '%' : 'No se aplica' }}</span>
          </div>
        </div>
      </div>

      <!-- Cocheras -->
      <div v-if="mostrarDescuentosCochera" class="seccion">
        <div class="titulo-seccion">Cocheras</div>

        <div class="sub-seccion">
          <div class="titulo-sub-seccion">
            <span>Descuento permanente</span>
          </div>
          <div class="contenido-sub-seccion">
            <span class="texto-seccion">{{ this.descuento_permanente_cocheras ? this.descuento_permanente_cocheras + '%' : 'No se aplica' }}</span>
          </div>
        </div>
      </div>

      <!-- Primer mes de facturación -->
      <div v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_VINCULADO_A_CONSORCIO" class="seccion">
        <div class="titulo-seccion">Primer mes de facturación</div>
        <hr class="linea-separadora">
        <div class="texto-seccion" v-if="!acuerdo_comercial_copy.periodo_inicio_facturacion">
          Sin definir (se facturará lo antes posible)
        </div>
        <div v-else class="texto-seccion">{{ acuerdo_comercial_copy.periodo_inicio_facturacion | formatFecha('MMMM yyyy') }}</div>
      </div>

      <!-- Observaciones para facturación -->
      <div v-if="!modo_eliminacion">

        <template v-if="acuerdo_comercial_copy.tipo_propuesta !== TIPO_ACUERDO_POR_DEFECTO && !(modo_creacion && acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_LIBRE)">

          <template v-if="activar_observaciones">
            <v-textarea
              label="Observaciones para facturación"
              no-resize
              outlined
              rounded
              placeholder="Este es un comentario para el área de facturación al respecto de este acuerdo ."
              v-model="acuerdo_comercial_copy.observaciones"
              hint="Opcional"
              persistent-hint
              maxlength="255"
              counter="255"
            >
            </v-textarea>

            <!-- Vinculada a mas de un consorcio (masiva) -->
            <template v-if="acuerdo_comercial_copy.consorcios_seleccionados && acuerdo_comercial_copy.consorcios_seleccionados.length > 1">
              <ca-chip
                :item="{'label': 'Se utilizará la misma observación para todos los consorcios. Podés editar cada acuerdo individualmente desde la sección Buscador.'}"
                disabled
                outline
                contentClass="chip-custom chip-informativo"
              >
                <div slot="izquierda">
                  <v-icon class="icon-info">info</v-icon>
                </div>
              </ca-chip>
            </template>
          </template>

          <a v-if="!this.activar_observaciones" class="label-agregar-observacion" @click="activar_observaciones = true">Agregar observaciones para facturación</a>

        </template>
      </div>
      <div v-else-if="acuerdo_comercial_copy.observaciones" class="mt-6">
        <div class="seccion">
          <div class="titulo-seccion">Observaciones para facturación</div>
          <hr class="linea-separadora">
          <v-textarea
            readonly
            auto-grow
            rows="1"
            hide-details
            solo
            flat
            no-resize
            v-model="acuerdo_comercial_copy.observaciones"
            class="textarea-observaciones"
          >
          </v-textarea>
        </div>
      </div>

      <!-- Slot utilizado para agregar algun componente luego de las observaciones de facturación -->
      <slot name="post-observaciones-facturacion"></slot>

      <!-- Establecer acuerdo por defecto -->
      <!-- Tiene que ser de la misma administración y esta ultima no tiene que tener seteada -->
      <template v-if="!modo_eliminacion && mostrarCheckSetearPorDefecto">
        <div class="seccion-checkbox-por-defecto px-4 pb-4 mt-6">
          <v-checkbox
            color="accent"
            label="Establecer como acuerdo por defecto"
            hint="Los nuevos consorcios de la administración serán asignados automáticamente con este acuerdo comercial."
            persistent-hint
            v-model="acuerdo_comercial_copy.establecer_propuesta_por_defecto"
          >
          </v-checkbox>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import { Consorcio } from '@/models/Consorcio';
import { AcuerdoComercial } from '../../../../models/AcuerdoComercial';
import * as acuerdo_comercial_constantes from '../../acuerdo-comercial.consts';
import { helperDestructurarDescuentosUfs } from '../../acuerdo-comercial.helpers';
import { getTituloTipoConsorcio } from '../../acuerdo-comercial.consts';
import { METADATA_GETTER_MINIMO_UFS_PLATAFORMA } from '@/store/metadata/metadata.types';

export default {
  name: 'VistaPreviaAcuerdo',
  props:{
    acuerdo_comercial: { type: AcuerdoComercial, default: () => null },

    // Flag utilizado para ocultar elementos
    modo_eliminacion: { type: Boolean, default: false },
    modo_creacion: { type: Boolean, default: false },
    modo_asignacion_libre: { type: Boolean, default: false},
  },
  data: () => ({

    // Descuentos ufs
    descuentos_temporales: [], // Arreglo para almacenar los descuentos temporales (dependiendo del length sera el codigo html renderizado)
    descuento_permanente_uf: null, // Solo puede haber un descuento de tipo permanente para uf principales
    descuento_permanente_cocheras: null, // Solo puede haber un descuento de tipo permanente para cocheras

    activar_observaciones: false,
    acuerdo_comercial_copy: null,

    consorcio_seleccionado: null,

    // Constantes usadas en el template
    TIPO_ACUERDO_LIBRE: acuerdo_comercial_constantes.TipoAcuerdo.LIBRE, // [acuerdo_libre - no esta en uso actualmente]
    TIPO_ACUERDO_POR_DEFECTO: acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION,
    TIPO_ACUERDO_VINCULADO_A_CONSORCIO: acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO,
    EDIFICIO: acuerdo_comercial_constantes.TipoConsorcio.EDIFICIO,
    BARRIO: acuerdo_comercial_constantes.TipoConsorcio.BARRIO,

    LABEL_MINIMO_UFS: 'Se habilitó facturar debajo del mínimo de UFs'
  }),
  computed:{
    /**
     * Computed para calcular el texto a mostrar en el Chip en el apartado de unidades unidades funcionales
     */
    itemUfsFacturarDebajo(){
      // Si es libre o por defecto y se definio el minimo ufs (si este ultimo no esta activo, no se muestra el chip)
      if (this.acuerdo_comercial_copy.tipo_propuesta === acuerdo_comercial_constantes.TipoAcuerdo.LIBRE || this.acuerdo_comercial_copy.tipo_propuesta === acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION){
        return this.acuerdo_comercial_copy.minimo_ufs ?
          {
            label: this.LABEL_MINIMO_UFS
          } : '';
      }
      else { // Vinculada y tiene menos del minimo de ufs permitidas

        // Si definio (checkeo) facturar por debajo
        if (this.acuerdo_comercial_copy.minimo_ufs){
          return {
            label: this.LABEL_MINIMO_UFS,
            label2: 'Se facturarán: ' + this.consorcio_seleccionado.cantidad_ufs_facturables + ' UFs'
          };
        }
        else{
          return {
            label: 'Se facturará el mínimo: ' + this.$store.getters[METADATA_GETTER_MINIMO_UFS_PLATAFORMA] + ' UFs'
          };
        }
      }
    },

    /**
     * Computed para detectar si debe mostrar el chip de unidades funcionales (nuevo minimo)
     */
    mostrarChipUnidadesFuncionales(){
      // Si es vinculada y tiene menos del minimo de ufs permitidas
      if (this.consorcio_seleccionado && this.consorcio_seleccionado.cantidad_ufs_facturables < this.$store.getters[METADATA_GETTER_MINIMO_UFS_PLATAFORMA]) {
        return true;
      }

      // Si es libre/por defecto y seteo un minimo [acuerdo_libre - no esta en uso actualmente]
      if ((this.acuerdo_comercial_copy.tipo_propuesta === acuerdo_comercial_constantes.TipoAcuerdo.LIBRE || this.acuerdo_comercial_copy.tipo_propuesta === acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION) && this.acuerdo_comercial_copy.minimo_ufs){
        return true;
      }

      return false;
    },

    /**
     * Computed para rellenar el select con los consorcios seleccionados del acuerdo
     * El label se distingue <administración> - <consorcio>
     * Varía de donde sacar el nombre la administración, si el acuerdo no tiene administración, es porque viene de consorcios pendientes y por lo tanto el nombre sale de cada consorcio, 
     * sino se toma el nombre de la administración del acuerdo comercial.
     */
    consorciosSeleccionables(){
      return this.acuerdo_comercial_copy.consorcios_seleccionados.map(consorcio => {
        const nombre_administracion = (!this.acuerdo_comercial_copy.administracion) ?  consorcio.administracion.nombre : this.acuerdo_comercial_copy.administracion.nombre;
        return {
          text: nombre_administracion + ' - ' + consorcio.nombre,
          value: consorcio
        };
      });
    },

    /**
     * Computed para mostrar checkbox de setear por defecto
     * Se puede activar por dos caminos distintos
     *   - Sea que venga desde consorcios pendientes
     *    - Para este caso hay que verificar el atributo que se agrega + no sean de distintas admin y además que ya no tenga acuerdo
     *   - Puede venir del circuito de creacion normal (boton crear acuerdo)
     *    - En este caso si la admin, de la cual selecciono consorcios, tiene ya un acuerdo, no se activa.
     */
    mostrarCheckSetearPorDefecto(){
      let mostrar_check = false;

      if (this.acuerdo_comercial_copy.tipo_propuesta === this.TIPO_ACUERDO_VINCULADO_A_CONSORCIO && !this.modo_asignacion_libre){

        // Chequeo si viene de consorcios pendientes (nuevos) o de circuito de creación (seleccion de consorcios)
        // atributo "distinta_administracion" se agrega solo en consorcios pendientes (nuevos)
        // eslint-disable-next-line no-prototype-builtins
        if (this.acuerdo_comercial_copy.hasOwnProperty('distinta_administracion')) {
          mostrar_check = !this.acuerdo_comercial_copy.distinta_administracion && !this.consorcio_seleccionado.propuesta_default;
        }
        else{ // Vino desde seleccion de consorcios
          mostrar_check = !this.acuerdo_comercial_copy.administracion.hasApiLink('propuesta_comercial');
        }
      }
      return mostrar_check;
    },

    /**
     * Computed para definir si se debe mostrar la sección de descuentos aplicados a la cochera
     * Esta sección depende del tipo de acuerdo que se este llevando acabo
     *  - Si es vinculada a consorcios, se define dependiendo el tipo del consorcio seleccionado
     *  - Cualquier otro caso, lo define el tipo de producto del AC
     */
    mostrarDescuentosCochera(){
      if (this.acuerdo_comercial_copy.tipo_propuesta === this.TIPO_ACUERDO_VINCULADO_A_CONSORCIO){
        return this.consorcio_seleccionado && this.consorcio_seleccionado.tipo !== this.BARRIO;
      }
      else{
        return this.acuerdo_comercial_copy.tipo_producto !== this.BARRIO;
      }
    }
  },
  watch:{
    /**
     * Watch para accionar y forzar la actualización de la vista ante un cambio del acuerdo comercial (considerado en profundidad nivel atributos)
     */
    acuerdo_comercial: {
      deep: true,
      handler(new_value){
        this.prepararVistaPrevia(new_value);
      }
    },
  },
  /**
   * Al montarse el componente, se crea una copia deep del AC original, para modificarla.
   */
  mounted(){
    this.prepararVistaPrevia(this.acuerdo_comercial);
  },
  methods: {
    getTituloTipoConsorcio, // Necesario para poder acceder desde template

    /**
     * Destructuro los descuentos temporales / permanentes
     * En otras palabas, se busca separar en variables para poder mostrarlos en la vista previa de mejor manera
     * Seria destructurar lo que se creo pero solo para ser mostrado
     */
    destructurarDescuentosUfs(){
      if(this.acuerdo_comercial_copy.descuentos_ufs){
        let descuentos = helperDestructurarDescuentosUfs(this.acuerdo_comercial_copy);
        [this.descuentos_temporales, this.descuento_permanente_uf, this.descuento_permanente_cocheras] = [...descuentos];
      }
      else{
        this.descuentos_temporales= [];
        this.descuento_permanente_uf= null;
        this.descuento_permanente_cocheras= null;
      }
    },

    /**
     * Obtengo la observacion actualizada, en caso que sea el usuario haya activado el textarea de observaciones
     * Metodo invocado desde el padre
     */
    emitirAcuerdoModificado(){
      if(this.activar_observaciones || this.acuerdo_comercial_copy.establecer_propuesta_por_defecto){
        this.$emit('update:acuerdo_comercial', this.acuerdo_comercial_copy);
      }
    },

    /**
     * Clona la vista previa para tenerla actualizada
     * Prepara el selector de consorcios (con el primer consorcio, en caso de vinculada a consorcio)
     */
    prepararVistaPrevia(ac){
      this.acuerdo_comercial_copy = _.cloneDeep(ac);

      this.acuerdo_comercial_copy.establecer_propuesta_por_defecto = false; // Flag para marcar si se quiere setear la ac como por defecto de la administracion

      this.destructurarDescuentosUfs(); // Destructuros los descuentos para formatearlos por si cambiaron

      // Preselecciono el primer consorcio en caso que sea vinculada a consorcio
      if (this.acuerdo_comercial_copy.tipo_propuesta === this.TIPO_ACUERDO_VINCULADO_A_CONSORCIO){
        if (this.modo_eliminacion){
          let consorcio = new Consorcio();
          consorcio.setDataFromStorage(this.acuerdo_comercial_copy.consorcio);
          this.consorcio_seleccionado = consorcio;
        }
        else{
          this.consorcio_seleccionado = this.acuerdo_comercial_copy.consorcios_seleccionados ? this.acuerdo_comercial_copy.consorcios_seleccionados[0] : null;
        }
      }

      // Activo observaciones en caso que las tenga
      this.activar_observaciones = !!this.acuerdo_comercial_copy.observaciones;

      this.actualizarRelacionConsorcio(); // Actualizo el consorcio seleccionado en el select de consorcios 
    },

    /**
     * Actualiza el consorcio seleccionado en el select de consorcios y emite el evento con el consorcio seleccionado al padre (solo si el modo es creación)
     */
    actualizarRelacionConsorcio() {
      if(this.modo_creacion && this.consorcio_seleccionado) {
        this.$emit('acuerdo-comercial:seleccionado', this.consorcio_seleccionado);
      }
    }
  },
};
</script>

<style lang="scss">
#vista-previa-acuerdo{

  .titulo-principal-celeste{
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: color(celeste-hover);
  }

  .selector-consorcio{
    border-radius: 5px;
    border: 1px solid color(gris);
    background-color: color(light);

    .label-eleccion-consorcio{
      color: color(gris-oscuro);
      font-size: 13px;
      line-height: 18px;
    }

    .v-text-field__details {
      display: none;
    }
  }

  .vista-previa {

    // Evito el foco en el textarea
    .textarea-observaciones {
      pointer-events: none;
    }

    .label-titulo-acuerdo{
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      color:color(dark);
      padding: 8px 5px 8px 6px;
    }

    .texto-seccion{
      padding: 8px 5px 8px 6px;
    }

    .seccion-checkbox-por-defecto{
      border: 1px solid color(gris);
      background: color(fondo-claro);
      border-radius: 5px;
      color: color(dark);
    }
  }
}
</style>